module.exports = __webpack_public_path__ + "assets/images/CNY1.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CNY1.png
// module id = 1342
// module chunks = 1